import React, { Component } from "react";
import { Menu, Icon } from "antd";
import "./css/DlMenu.less";
import emptyStyle from "./css/empty.css";
const { SubMenu } = Menu;

const Empty = () => {
  return (
    <div className={emptyStyle.empty}>
      您无系统菜单权限，
      <br />
      请联系管理员进行设置
    </div>
  );
};
export default class DlMenu extends Component {
  
  state = {
    CurrtentUid: "", //当前菜单id
    openKeys: [],
  };
  itemClick = (item) => {
    this.setState({
      CurrtentUid: item.uid,
    });
    tool.sgiLogger.time("storage清理");
    // 清除页面uuid的storage缓存
    tool.sgiStorage.removeByPrefix(sgiConfig.keyPre_uuid);
    // 清除回显storage缓存
    tool.sgiStorage.removeByPrefix(sgiConfig.keyPre_echo);
    tool.sgiLogger.timeEnd("storage清理");
    tool.sgiLogger.time("正常跳转");
    tool.sgiLogger.info(item);
    tool.initBreadcrumbArr();
    tool.jumpByBrowserHistory(item.routeParam, {
      uid: item.uid,
      "@optParam": item.optParam,
      "@excuteInfo": item.excuteInfo,
      name: item.menuNam,
    });
    tool.sgiLogger.timeEnd("正常跳转");
    tool.sgiLogger.time("setTimeout清理");
    // 渲染完成后，再次清理回显storage缓存
    setTimeout(() => {
      tool.sgiStorage.removeByPrefix(sgiConfig.keyPre_echo);
    }, 0);
    tool.sgiLogger.timeEnd("setTimeout清理");
    document.body.click();
  };

  loopMenu = (menus) => {
    let defaultProps = {
      code: "menuId",
      name: "menuNam",
    };
    return menus.map((item) => {
      if (item.children && item.children.length) {
        return (
          <SubMenu
            key={item[defaultProps.code]}
            title={
              <span>
                <Icon type="appstore" />
                <span>{item[defaultProps.name]}</span>
              </span>
            }
          >
            {this.loopMenu(item.children)}
          </SubMenu>
        );
      }
      return (
        <Menu.Item
          onClick={() => this.itemClick(item)}
          key={item[defaultProps.code]}
          title={item[defaultProps.name]}
        >
          {item[defaultProps.name]}
        </Menu.Item>
      );
    });
  };

  onOpenChange = (keys) => {
    let rootSubmenuKeys = this.props.navMenus.map(el=>el['menuId']) || []
    const latestOpenKey = keys.find(key => this.state.openKeys.indexOf(key) === -1)
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      this.setState({ openKeys:keys })
    } else {
      this.setState({
        openKeys: latestOpenKey ? [latestOpenKey] : []
      })
    }
  }

  render() {
    let isEmpty = this.props.navMenus.length === 0;
    return !isEmpty ? (
      <Menu
        className="DlMenu"
        mode="inline"
        openKeys={this.state.openKeys}
        onOpenChange={this.onOpenChange}
        style={{ width: 200 }}
      >
        {this.loopMenu(this.props.navMenus)}
      </Menu>
    ) : (
      <Empty></Empty>
    );
  }
}



// WEBPACK FOOTER //
// ./apps/pages/main/layout/DlMenu.js